import { BodyLarge } from '@common/body';

export const TitleEmoji = ({ children }: { children: string }): JSX.Element => (
  <div className="mb-2 mt-8">
    <BodyLarge>
      <span className="text-[48px]">{children}</span>
    </BodyLarge>
  </div>
);
